import { Action, createReducer, on } from '@ngrx/store';
import { BranchSettingsActions } from '../actions';
import { BranchSettingsStates } from '../states';
import { initialState } from '../states/branch-settings.states';

export const branchSettingsFeatureKey = 'branchSettings';

export const branchSettingsReducer = createReducer(
    initialState,
    on(BranchSettingsActions.selectEmployeeLinkSuccess, (state, action) => {
      console.log('Previous state:', state);
      console.log('Action payload:', action.container);

      const updatedState = { ...state, selectedEmployeeLink: action.container };
      console.log('Updated state:', updatedState);

      return updatedState;
    }),

    on(BranchSettingsActions.selectEmployeeLink, (state, action) =>
      ({...state, selectedEmployee: action.employee})),
    on(BranchSettingsActions.selectDefaultPrintableFormatSucess, (state, action) => ({...state,  selectedDefaultFormat: action.container})),
    on(BranchSettingsActions.selectPrintableImageLink, (state, action) =>
      ({...state, selectedPrintableImageLink: action.image})),
    on(BranchSettingsActions.selectFileSuccess, (state, action) =>
      ({...state, selectedPrintableImageFile: action.file})),
    on(BranchSettingsActions.selectPrintableImage, (state, action) =>
      ({...state, selectedPrintableImage: action.image})),
    on(BranchSettingsActions.selectPrintable, (state, action) =>
      ({...state, selectedPrintable: action.printable})),
    on(BranchSettingsActions.selectBranchSettlementMethodListSucess, (state, action) => ({...state,  branchSettlementMethodList: action.container})),
    on(BranchSettingsActions.selectBranch, (state, action) =>
    ({...state, selectedBranch: action.container})),
    on(BranchSettingsActions.resetSettingItemFilter, (state, action) =>
    ({...state, selectedItemCategoryFilter:[]})),
    on(BranchSettingsActions.selectSettingItemFilterSuccess, (state, action) =>
    ({...state, selectedItemCategoryFilter:action.setting})),
)

export function reducer(state: BranchSettingsStates | undefined, action: Action) {
    return branchSettingsReducer(state.branchSettings, action);
}
